import { createContext, useMemo } from "react";
import { useGetRecommendedDoseQuery } from "src/api/services/titrationApi";
import { OneTimeProduct, ProductCategories } from "src/api/types";
import { useLatestOrder } from "../LatestOrder";
import { skipToken } from "@reduxjs/toolkit/query";

export const RecommendedDosageContext = createContext<
  OneTimeProduct | undefined | null
>(null);

interface Props {
  children: React.ReactNode;
}

const RecommendedDosageProvider = ({ children }: Props) => {
  const latestOrder = useLatestOrder((o) => o);

  const { data } = useGetRecommendedDoseQuery(
    latestOrder?.product_category.name === ProductCategories.WeightLoss &&
      latestOrder.product.is_glp1
      ? {
          billing_model: latestOrder.product.billing_model,
          product_id: latestOrder.product.id,
        }
      : skipToken,
  );

  const recommendedDose = useMemo(() => {
    if (data == null) return null;

    return data;
  }, [data]);

  return (
    <RecommendedDosageContext.Provider value={recommendedDose}>
      {children}
    </RecommendedDosageContext.Provider>
  );
};

export default RecommendedDosageProvider;
